import { Children, FunctionComponent, HTMLAttributes } from 'react';

// libs
import classnames from 'classnames';

// Components

// Styles
import styles from './Masonry.module.scss';

interface MasonryProps {
    className?: string;
    colsNumber?: number;
    columnClassName?: string;
    columnAttrs?: HTMLAttributes<HTMLDivElement>;
}

const DEFAULT_COLUMNS = 2;

const Masonry: FunctionComponent<MasonryProps> = ({
    colsNumber,
    className,
    children,
    columnAttrs,
    columnClassName,
}) => {
    const itemsInColumns = () => {
        const currentColumnCount = colsNumber;
        const itemsInColumns = new Array(currentColumnCount);

        // Force children to be handled as an array
        const items = Children.toArray(children);

        for (let i = 0; i < items.length; i++) {
            const columnIndex = i % currentColumnCount;

            if (!itemsInColumns[columnIndex]) {
                itemsInColumns[columnIndex] = [];
            }

            itemsInColumns[columnIndex].push(items[i]);
        }

        return itemsInColumns;
    };

    const renderColumns = () => {
        const childrenInColumns = itemsInColumns();
        const columnWidth = `${100 / childrenInColumns.length}% `;

        const columnAttributes = {
            ...columnAttrs,
            style: {
                width: `${columnWidth}`,
                ...columnAttrs?.style,
            },
            className: classnames([styles.column, columnClassName]),
        };

        return childrenInColumns.map((items, i) => {
            return (
                <div {...columnAttributes} key={i}>
                    {items}
                </div>
            );
        });
    };

    const wrapperClassName = classnames([styles.wrapper, className]);
    return <div className={wrapperClassName}>{renderColumns()}</div>;
};

Masonry.defaultProps = {
    className: '',
    columnClassName: '',
    colsNumber: DEFAULT_COLUMNS,
};

export default Masonry;
